<script>
  import VideosList from "@/components/intranet/teamworkup-tv/VideosList.vue";
  import Spinner from "@/components/intranet/Spinner.vue";
  import { mapState, mapActions } from "vuex";
  import SendSvg from "@/assets/img/icon/SendSvg.vue";

  export default {
    components: {
      Spinner,
      VideosList,
      SendSvg
    },
    data() {
      return {
        videoPlaying: false,
        texto_comentario: "",
        texto_respuesta: "",
        texto_editando: "",
        comentarios: [],
        id_usuario_actual: this.$ls.get("user").id_usuario,
        id_modulo: "6",
        show_spinner: false,
        selected_video_id: this.$route.params.id
      };
    },

    computed: {
      ...mapState("VideoModule", ["featuredVideo", "paginacionTotalVideos", "videosPlataforma"]),

      video() {
        return this.featuredVideo;
      }

    },
    methods: {
      ...mapActions("VistosModule", ["insertVisto"]),
      ...mapActions("VideoModule", ["getUnVideo", "crearComentariosEmpresaVideo", "editarComentarioEmpresaVideo",
        "eliminarComentarioEmpresaVideo", "addLikeVideo", "delLikeVideo", "addLikeComentarioEmpresa", "delLikeComentarioEmpresa", "getPaginacionVideos", "getVideosPaginados"]),

        insertVistos() {
          let data_ = {
            id_empresa: this.$ls.get("user").id_empresa_fk,
            id_usuario: this.$ls.get("user").id_usuario,
            id_modulo: this.id_modulo,
            id_objeto: this.$route.params.id,
          };
          this.insertVisto(data_); 
        },
      onLastVideoSelect(videoId) {
        this.selected_video_id = videoId;
      },

      async getVideoSingle() {
        const data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_video: this.selected_video_id
        }
        this.show_spinner = true;
        await this.getUnVideo(data_);
        this.comentarios = this.video.comentarios;
        this.show_spinner = false;
      },
      playOrPause() {
        const video = document.getElementById("video");
        video.volume = 0.5;

        if (video.paused) {
          this.videoPlaying = true;
          video.play();
        } else {
          this.videoPlaying = false;
          video.pause();
        }
      },
      fechaConPuntos(date) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);

        return newDate
          .toLocaleString("es-CL", {
            day: "numeric",
            month: "numeric",
            year: "numeric",
          })
          .replace(/-/g, ".");
      },
      horaLegible(date) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);

        return newDate.toLocaleString("es-CL", {
          hour: "numeric",
          minute: "numeric",
        });
      },
      async toggleLike(video) {
        const liked = !!video.confirm_like;
        const data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_objeto: video.id_video,
        };
        if (!liked) {
          await this.addLikeVideo(data_);
        } else {
          await this.delLikeVideo(data_);
        }

      },
      async handleSubmitComentario(comentario_padre = "") {
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_objeto: this.$route.params.id,
          id_modulo: this.id_modulo,
          texto: comentario_padre == "" ? this.texto_comentario : this.texto_respuesta,
          id_comentario: comentario_padre,
          menciones: ""
        }
        // esto solo va dado que no se implementa en está iteración el comentario del comentario
        if (comentario_padre == "") {
          await this.crearComentariosEmpresaVideo(data_);
        }

        this.texto_comentario = "";
        this.texto_respuesta = "";
      },
      async eliminarComentario(id_comentario) {
        let id_respuestas = false;
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_objeto: this.$route.params.id,
          id_modulo: this.id_modulo,
          id_comentario: id_respuestas == false ? id_comentario : id_respuestas,
        }
        //console.log("datos para eliminar: ", data_);
        if (id_respuestas == false) {
          //console.log("comentario eliminar");
          await this.eliminarComentarioEmpresaVideo(data_);
        }
        else {
          //console.log("comentario del comentario eliminar ");
          await this.eliminarComentarioDelComentario(data_);
        }
      },
      async toggleLikeComentario(id_comentario, liked) {
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_objeto: this.$route.params.id,
          id_modulo: this.id_modulo,
          id_comentario: id_comentario,
          id_like: ""
        }
        if (!liked) {
          await this.addLikeComentarioEmpresa(data_);
        }
        else {
          await this.delLikeComentarioEmpresa(data_);
        }
        this.$forceUpdate();
      },
      toggleEditingComentario(comentario) {
        this.accion_editar = !this.accion_editar;
        let texto_ed = ""
        comentario.isEditing = !comentario.isEditing;
        texto_ed = comentario.texto;
        this.texto_editando = texto_ed;
        this.$forceUpdate();
      },
      async editarComentario(comentario, id_respuestas) {
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          id_objeto: this.$route.params.id,
          id_modulo: this.id_modulo,
          texto: this.texto_editando,
          id_comentario: id_respuestas == false ? comentario.id_comentario : id_respuestas,
          menciones: ""
        }
        if (id_respuestas == false) {
          console.log("comentario ");
          await this.editarComentarioEmpresaVideo(data_);
        }
        else {
          console.log("comentario del comentario");
        }
        this.texto_editando = "";
      },

      //FF
      play() {
        const video = document.getElementById("video");
        video.volume = 0.5;
        this.videoPlaying = true;
        video.setAttribute("controls","controls")
        if (video.paused) {
          video.play();
        }
      },

      textareaComentario() {
        let textarea = document.querySelector("#textarea-comentario");
        if(this.texto_comentario === "") {
          textarea.style.height = "63px";
          return
        }
        textarea.style.height = "1px";
        textarea.style.height = (25 + textarea.scrollHeight) + "px";
      },
      async getVideos() {
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          nombre: "",
          id_categoria: "0",
          reciente_visto: "1",
          limite: "4",
          dispositivo: ""
        }
        await this.getPaginacionVideos(data_).then(res => {
          if (res) this.getUlimos(res[0].videos)
        });
      },
      async getUlimos(id_videos) {
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk,
          id_usuario: this.$ls.get("user").id_usuario,
          ids: id_videos
        }
        await this.getVideosPaginados(data_);
      }
    },
    async created() {
      await this.getVideoSingle();
      this.getVideos();
      this.insertVistos()
    },
    beforeRouteUpdate(to, from, next) {
      //console.log("Acá en beforeUpdateRouter", next);
      //this.getVideoSingle();
      //this.getVideos();
      next();
      window.location.reload();
    },
  };
</script>

<template>

  <section id="video-single">

    <div class="row">
      <div class="col-12">
        <h1 class="h1-custom font-700 mb-1 color-main">
          {{ video.titulo_video }}
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link 
                to="/videos"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-video"></font-awesome-icon>
                Videos
              </router-link>
            </li>
            <li class="breadcrumb-item active">
              {{ video.titulo_video }}
            </li>
          </ol>
        </nav>

        <div class="row">
          <div class="col-12">
            <p class="text-secondary h5-custom mb-0">
              ¡Entérate de todas nuestras novedades! Filtra las noticias seleccionando una categoría.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="border-bottom mb-3 pb-3"></div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 col-lg-7 mb-3">
          <div class="card border-0">
            <div class="card-body">
              <div class="w-100 position-relative ratio ratio-16x9">
                <video 
                  id="video" 
                  v-if="!show_spinner"
                  controlsList="nodownload"
                  class="video-tw-tv pointer-event">
                  <source :src="video.url_video"/>
                </video>
                <a 
                  @click="play()" 
                  v-if="!videoPlaying"
                  class="pointer-event d-flex justify-content-center align-items-center"
                >
                  <span class="video-single-play">
                    <span class="video-single-play-content">
                      <font-awesome-icon icon="fa-solid fa-play" class="video-single-play-icon"></font-awesome-icon>
                    </span>
                  </span>
                </a>
              </div>

              <div class="row mt-3">
                <div class="col-12">
                  <h4 class="font-main font-700 color-main">
                    {{ video.titulo_video }}
                  </h4>
                  <span class="d-flex justify-content-between">
                    <span class="text-secondary">
                      {{ fechaConPuntos(video.fecha_video)}}
                    </span>
                    <div> 
                      <a 
                        href="javascript:"
                        @click="toggleLike(video)"
                        class="card-custom-footer-like color-main"
                      >
                        <span v-if="!video.confirm_like" key="solid-heart">
                          <font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
                        </span>
                        <span v-else key="regular-heart">
                          <font-awesome-icon icon="fa-solid fa-heart" class="color-red"></font-awesome-icon>
                        </span>
                      </a>
                      <span class="card-custom-footer-like-count ms-1">
                        {{ video.likes?.length }}
                      </span>
                    </div>
                  </span>
                  <p class="text-secondary">
                      {{ video.descripcion_video }}
                    </p>
                </div>
              </div>

            </div>
          </div>
      </div>
      <div class="col-12 col-lg-5 mb-3">

        <div class="card border-0 mb-3">
            <div class="card-body">
              <form @submit.prevent="handleSubmitComentario('')">
                <textarea 
                  @keyup="textareaComentario()"
                  id="textarea-comentario"
                  class="textarea-auto"
                  placeholder="Escribe un comentario ..." 
                  rows="3"
                  v-model="texto_comentario"
                  maxlength="255"
                ></textarea>
                <div class="row">
                  <div class="col-12 d-flex justify-content-between">
                    <div class="form-text text-end text-secondary">
                      {{ texto_comentario.length }} / 255 caracteres
                    </div>
                    <button 
                      type="submit"
                      class="btn btn-link transition-all p-0 color-main"
                    >
                      <SendSvg/>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="over-y mxh-470">
            <div 
              v-for="comentario in video.comentarios" 
              :key="comentario.id_comentario"
              class="card border-0 mb-3" 
            >
            <div class="card-body">
  
              <div class="d-flex">
                <div class="flex-shrink-0 avatar-user">
                  <img 
                    width="50" 
                    v-if="comentario.usuario[0].imagen_perfil || /.jpg|.jpeg|.png/.test(comentario.usuario[0].imagen_perfil)" 
                    :src="comentario.usuario[0].imagen_perfil" 
                    class="img-object-cover rounded-circle me-3"
                    alt="Imagen de usuario"
                  />
                  <img 
                    v-else 
                    width="50"
                    src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                    class="img-object-cover rounded-circle me-3"
                    alt="Imagen de usuario" 
                  />
                  <span class="avatar-user-online"></span>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex mb-3">
                    <div class="flex-grow-1">
                      <h5 class="font-700 h5-custom text-secondary mb-0">
                        {{ capitalizeFirstLetter(comentario.usuario[0].primer_nombre) }}
                        {{ capitalizeFirstLetter(comentario.usuario[0].apellido_paterno) }}
                      </h5>
                      <span class="text-secondary text-opacity-50">
                        <font-awesome-icon icon="fa-solid fa-calendar"></font-awesome-icon> 
                        22.03.23
                        <font-awesome-icon icon="fa-solid fa-clock"></font-awesome-icon>
                        18:08
                      </span>
                    </div>
                    <div class="flex-shrink-0 d-flex align-items-start">
                      <button 
                          v-if="comentario.usuario[0].id_usuario === id_usuario_actual" 
                          @click="toggleEditingComentario(comentario)" 
                          class="btn btn-sm btn-custom-line btn-custom-line-gray border-0"
                          data-bs-toggle="tooltip" 
                          data-bs-placement="right"
                          data-bs-custom-class="tooltip-custom tooltip-custom-main"
                          data-bs-title="Nueva auditoría"
                        >
                        <font-awesome-icon icon="fa-solid fa-pen" ></font-awesome-icon>
                      </button>
                      <button 
                        v-if="comentario.usuario[0].id_usuario === id_usuario_actual" 
                        @click=" eliminarComentario(comentario.id_comentario, false)" 
                        class="btn btn-sm btn-custom-line btn-custom-line-gray ms-2 border-0"
                      >
                      <font-awesome-icon icon="fa-solid fa-trash" ></font-awesome-icon>
                      </button>
                    </div>
                  </div>
                  <p class="text-secondary text-opacity-75">    
                    <template v-if="!comentario.isEditing">
                      {{ comentario.texto }}                       
                    </template>       
                    <template v-if="comentario.isEditing">
                      <textarea 
                        class="textarea-auto textarea-120" 
                        rows="3"
                        v-model="texto_editando" 
                        maxlength="255"></textarea>
                      <div class="d-flex justify-content-between">
                        <div>
                          <button 
                            class="btn btn-sm btn-custom-line-main" 
                            @click="editarComentario(comentario, false)"
                          >
                            <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>
                            Guardar
                          </button>
                          <button 
                            class="btn btn-sm btn-custom-line-dark ms-2" 
                            @click="toggleEditingComentario(comentario)"
                          >
                            <font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
                            Cancelar
                          </button>
                        </div>
                        <div class="form-text text-end text-secondary">
                          {{ texto_editando.length }} / 255
                        </div>
                      </div>
                    </template>
                  </p>
                  <div class="flex-shrink-0 d-flex justify-content-end">
                    <a 
                      href="javascript:"
                      @click="toggleLikeComentario(comentario.id_comentario, comentario.likes.some((like) => like.usuario[0].id_usuario == id_usuario_actual))"
                      class="card-custom-footer-like color-main"
                    >
                      <span 
                        v-if="comentario.likes.length === 0" 
                        key="solid-heart"
                      >
                        <font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
                      </span>
                      <span 
                        v-if="comentario.likes.length > 0" 
                        key="regular-heart"
                      >
                        <font-awesome-icon icon="fa-solid fa-heart" class="color-red"></font-awesome-icon>
                      </span>
                      <span class="card-custom-footer-like-count">
                        {{ comentario.likes.length }}
                      </span>
                    </a>
                </div>
                </div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>

    <div 
      v-if="!show_spinner" 
      class="row"
    >
      <div class="col-12">
        <div class="card border-0 card-shadow my-3">
          <div class="card-body">
            <h3 class="color-main font-700 text-center">Últimos videos</h3>
            <VideosList :data="videosPlataforma"/>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="show_spinner"/>
  </section>

</template>